import script from "./ProductListGrid.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductListGrid.vue?vue&type=script&lang=ts&setup=true"

import "./ProductListGrid.vue?vue&type=style&index=0&id=02fefc7e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02fefc7e"]])

export default __exports__